import { useState } from 'react';
export function useValidated(onValidateCallback) {
    const [errors, setErrors] = useState([]);
    const [isValid, setIsValid] = useState(true);
    const onValidate = (validationErrors) => {
        setErrors(validationErrors);
        setIsValid(validationErrors.length === 0);
        if (onValidateCallback)
            onValidateCallback(validationErrors);
    };
    return [errors, onValidate, isValid];
}
